import { useState } from 'react';
import { useUnityBuildStore } from '../../stores/store';
import { useStore } from 'zustand';
import { GetProjectResponse } from '../../api/protosCompiled/project/project_pb';
import { ProjectListWithHierarchy } from './ProjectListWithHierarchy';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTheme as useCustomTheme } from '../../contexts/ThemeContext';
import { numenorColors } from '../../theme/themeConfig';
import { useFetchUser } from '../../hooks/useFetchUsers';

export function ProjectList() {
  const { darkMode } = useCustomTheme();

  const setIsViewingEstimateList = useStore(useUnityBuildStore).setIsViewingEstimateList;
  const setSelectedProject = useStore(useUnityBuildStore).setSelectedProject;

  const { data: user } = useFetchUser();

  const [isCreatingProject, setIsCreatingProject] = useState(false);
  const [isUpdatingProject, setIsUpdatingProject] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState('');

  const handleLoadProject = async (project: GetProjectResponse.AsObject) => {
    if (!project.project) return;
    setSelectedProject(project.project);
    setIsViewingEstimateList(true);
  };

  const handleEditProject = (project: GetProjectResponse.AsObject) => {
    if (!project.project) return;
    setIsUpdatingProject(true);
    setSelectedProjectId(project.project.id);
  };

  const handleCloseDialog = () => {
    setIsCreatingProject(false);
    setIsUpdatingProject(false);
  };

  const handleCreateProject = () => {
    setIsCreatingProject(true);
  };

  // Background with blueprint image
  const backgroundStyle = darkMode
    ? {
        background: `
          linear-gradient(135deg, ${alpha('#111827', 0.85)} 0%, ${alpha('#1f2937', 0.85)} 50%, ${alpha('#111827', 0.85)} 100%),
          url('/desktop_blueprint.webp')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }
    : {
        background: `
          linear-gradient(135deg, ${alpha(numenorColors[50], 0.78)} 0%, ${alpha(numenorColors[100], 0.78)} 50%, ${alpha(numenorColors[50], 0.78)} 100%),
          url('/desktop_blueprint.webp')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        ...backgroundStyle,
        position: 'relative',
        overflow: 'auto',
        p: 2,
      }}
      role="region"
      aria-label="Projects list"
    >
      <ProjectListWithHierarchy
        onCreateProject={handleCreateProject}
        onEditProject={handleEditProject}
        onLoadProject={handleLoadProject}
        isCreatingProject={isCreatingProject}
        isUpdatingProject={isUpdatingProject}
        selectedProjectId={selectedProjectId}
        onCloseDialog={handleCloseDialog}
        userId={user?.user?.id ?? ''}
      />
    </Box>
  );
}
